<div *commonUiOptionalWizardStep>
    <div class="pt-1">
        <div class="d-flex justify-content-between">
            <h2>{{ 'COMMON_UI.FRAGEBOGEN.BETRIEBSTAETTEN.TITEL' | translate }}</h2>
            <common-ui-daten-uebernahme
                    (picked)="onBetriebstaettePicked($event)" *ngIf="data?.betriebstaetten?.length < 10"
                    [itemTemplate]="datenuebernahmeBetriebstaetten" [items]="stammdaten?.unternehmen?.betriebstaetten"
                    [readonly]="readonly"
                    context="Betriebstaette">
            </common-ui-daten-uebernahme>
        </div>
        <div id="eric-error-massages" class="word-break"></div>
    </div>

    <div *ngIf="showMaxLimitHint" class="col-sm-12 col-lg-12 p-0 mt-1x">
        <common-ui-card
                [message]="'COMMON_UI.FRAGEBOGEN.MAX_LIMIT_HINT' | translate"
                type="info">
        </common-ui-card>
    </div>

    <div class="form-row mt-3x">
        <button
                (click)="addBetriebstaette()" *ngIf="!readonly && data?.betriebstaetten?.length < 10"
                class="btn btn-light ml-2 mb-2"
                id="addBetriebstaette"
                title="{{ 'COMMON_UI.FRAGEBOGEN.BETRIEBSTAETTEN.ADD_BETRIEBSTAETTE' | translate }}">
            <em class="icon icon-svg icon-fi-hinzufuegen"></em>
            {{ 'COMMON_UI.FRAGEBOGEN.BETRIEBSTAETTEN.ADD_BETRIEBSTAETTE' | translate }}
        </button>
    </div>

    <div class="mb-5x">
        <ul class="list-group d-flex" id="betriebstaettenList">
            <ng-container *ngFor="let betriebstaette of data.betriebstaetten; let i = index">
                <li
                        id="betriebstaette{{i}}"
                        class="list-group-item common-ui-list-group-item"
                        [tabIndex]="0"
                        (click)="toggleSelect(i)"
                        (keypress)="toggleSelect(i)"
                        [ngClass]="{'list-group-item-selected': selectedIndex == i}">
                    <div [ngClass]="{'active': selectedIndex === i }"
                         class="h5 list-group-item-heading ml-2x mb-0 list-item-title text-truncate">
                        {{betriebstaette?.bezeichnung}}
                    </div>
                    <div class="common-ui-remove-element">
                        <button
                                (click)="removeBetriebstaette(i)" *ngIf="!readonly && data?.betriebstaetten?.length > 0"
                                class="btn btn-light btn-img"
                                id="removeBetriebstaette{{i}}"
                                title="{{ 'COMMON_UI.FRAGEBOGEN.BETRIEBSTAETTEN.REMOVE_BETRIEBSTAETTE' | translate }}">
                            <em class="icon icon-svg icon-fi-loeschen"></em>
                        </button>
                    </div>
                </li>
                <div [ngClass]="(selectedIndex === i) ? 'display-list-item-form' : 'hide-list-item-form'"
                     class="containing-form w-100">
                    <div *ngIf="!showSpecial">
                        <common-ui-betriebstaette-form
                            [readonly]="readonly"
                            [betriebstaette]="betriebstaette"
                            [stammdaten]="stammdaten?.unternehmen?.betriebstaetten"
                            [index]="i"
                        >
                        </common-ui-betriebstaette-form>
                    </div>
                    <div *ngIf="showSpecial">
                        <common-ui-betriebstaette-special-form
                            [betriebstaette]="betriebstaette"
                            [readonly]="readonly"
                            [index]="i"
                        >
                        </common-ui-betriebstaette-special-form>
                    </div>
                </div>
            </ng-container>
        </ul>
    </div>
</div>

<ng-template #datenuebernahmeBetriebstaetten let-item="item">
    <h4 class="list-group-item-heading">{{item?.value.bezeichnung}}</h4>
    <div class="list-group-item-text">
        <p *ngIf="item?.value.inlandsadresse">
            {{item.value.inlandsadresse.strasse}} {{item.value.inlandsadresse.hausnummer}} {{item.value.inlandsadresse.hausnummernzusatz}}
            <br *ngIf="item.value.inlandsadresse.adressergaenzung">{{item.value.inlandsadresse.adressergaenzung}}
            <br>{{item.value.inlandsadresse.postleitzahl}} {{item.value.inlandsadresse.ort}}
        </p>
        <p *ngIf="item?.value.auslandsadresse">
            {{item.value.auslandsadresse.strasse}} {{item.value.auslandsadresse.hausnummer}} {{item.value.auslandsadresse.hausnummernzusatz}}
            <br *ngIf="item.value.auslandsadresse.adressergaenzung">{{item.value.auslandsadresse.adressergaenzung}}
            <br>{{item.value.auslandsadresse.postleitzahl}} {{item.value.auslandsadresse.ort}}
            <span *ngIf="item.value.auslandsadresse.land"><br>{{ 'COMMON_UI.ADRESSEN.AUSLANDSADRESSE.LAND.KEY_' +
            item.value.auslandsadresse.land | translate }}</span>
        </p>
        <p *ngIf="item?.value.kommunikationsmittel">
            <br>
            <span *ngFor="let telefonnummer of item.value.kommunikationsmittel.telefonnummern; let y=index">
        <br *ngIf="y !== 0">{{telefonnummer.vorwahlInternational}} {{telefonnummer.vorwahlNational}}
                {{telefonnummer.rufnummer}}
      </span>
            <span *ngIf="item.value.kommunikationsmittel.internet">
        <br>{{item.value.kommunikationsmittel.internet.internet}}</span>
        </p>
    </div>
</ng-template>
